import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    apiURL: 'http://localhost:8080',
    currentUser: {},
    signedIn: false
  },
  mutations: {
    setApiUrl (state, { url }) {
      state.apiURL = url
    },
    setCurrentUser (state, { currentUser }) {
      state.currentUser = currentUser
      state.signedIn = true
    },
    unsetCurrentUser (state) {
      state.currentUser = {}
      state.signedIn = false
    }
  },

  getters: {
    forSea: (state) => (shipmentType, cntx) => {
      return shipmentType == cntx.$getConstShipmentType('SHIPMENT_TYPE_SEA') ? true : false

    },
    getDeliveryStatusColor: (state) => (statusId, cntx) => {
      if(statusId == cntx.$getConstDeliveryStatus('DELIVERY_STATUS_CREATED')){
        return 'pending-color'
      }else if(statusId == cntx.$getConstDeliveryStatus('DELIVERY_STATUS_OUT_FOR_DELIVERY')){
        return 'ongoing-color'
      }else if(statusId == cntx.$getConstDeliveryStatus('DELIVERY_STATUS_DELIVERED')){
        return 'success'
      }
    },
    getInvoiceStatusColor: (state) => (statusId, cntx) => {
      if(statusId == cntx.$getConstInvoiceStatus('INVOICE_STATUS_CREATED')){
        return 'pending-color'
      }else if(statusId == cntx.$getConstInvoiceStatus('INVOICE_STATUS_SENT')){
        return 'account-invoice-sent-color'
      }else if(statusId == cntx.$getConstInvoiceStatus('INVOICE_STATUS_PAID')){
        return 'success'
      }else if(statusId == cntx.$getConstInvoiceStatus('INVOICE_STATUS_VOID')){
        return 'processing-color'
      }else if(statusId == cntx.$getConstInvoiceStatus('INVOICE_STATUS_DELETED')){
        return 'processing-color'
      }
    },

    getRewardStatusColor: (state) => (statusId, cntx) => {
      if(statusId == cntx.$getConstRewardStatus('REWARD_FOR_CONFIRMATION')){
        return 'info'
      }else if(statusId == cntx.$getConstRewardStatus('REWARD_SUCCESS')){
        return 'success'
      }else if(statusId == cntx.$getConstRewardStatus('REWARD_DECLINED')){
        return 'error'
      }
    },
    getStatusColor: (state) => (statusId, cntx) => {
      if(statusId == cntx.$getConstBookingStatus('BOOKING_STATUS_PENDING')){
        return 'pending-color'
      }else if(statusId == cntx.$getConstBookingStatus('BOOKING_STATUS_AGENT_VIEWED')){
        return 'agent-viewed-color'
      }else if(statusId == cntx.$getConstBookingStatus('BOOKING_STATUS_PROCESSING')){
        return 'processing-color'
      }else if(statusId == cntx.$getConstBookingStatus('BOOKING_STATUS_ONGOING')){
        return 'ongoing-color'
      }else if(statusId == cntx.$getConstBookingStatus('BOOKING_STATUS_ARRIVED')){
        return 'for-invoice-color'
      }else if(statusId == cntx.$getConstBookingStatus('BOOKING_STATUS_INVOICE_CREATED')){
        return 'invoice-created-color'
      }else if(statusId == cntx.$getConstBookingStatus('BOOKING_STATUS_INVOICE_SENT')){
        return 'invoice-sent-color'
      }else if(statusId == cntx.$getConstBookingStatus('BOOKING_STATUS_FOR_DELIVERY')){
        return 'for-delivery-color'
      }else if(statusId == cntx.$getConstBookingStatus('BOOKING_STATUS_DELIVERED')){
        return 'success'
      }else if(statusId == cntx.$getConstBookingStatus('BOOKING_STATUS_COMPLETED')){
        return 'success'
      }else if(statusId == cntx.$getConstBookingStatus('BOOKING_STATUS_CANCELLED')){
        return 'red'
      }
    },
    getUserInitial: (state) => (name) => {
      return name.charAt(0).toUpperCase()
    },
    getApiUrl (state) {
      return state.apiURL
    },
    getMyInitial (state) {
      return state.signedIn ? state.currentUser.first_name.charAt(0).toUpperCase() + state.currentUser.last_name.charAt(0).toUpperCase() : ''
    },
    getFullname (state) {
      return state.signedIn ? state.currentUser.first_name + ' ' + state.currentUser.last_name : ''
    },
    capitalise: (state) => (str) => {
      const arr = str.split(" ")
      for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1).toLowerCase()
      }
      return arr.join(" ")
    },
    getCurrentUser (state) {
      return state.currentUser
    },
    getSignedIn (state) {
      return state.signedIn
    },
    formatNumberAmount: (state) => (numeral, number) => {
      return numeral(number).format('0,0.00')
      // const numberFormat = new Intl.NumberFormat('en-US')
      // return numberFormat.format(number)
    },
    // formatNumberCBMAmount: (state) => (numeral, number) => {
    //   const numberFormat = new Intl.NumberFormat('en-US')
    //   return numberFormat.format(number)
    // },
    formatNumberAmountNoComma: (state) => (numeral, number) => {
      return numeral(number).format('0.000')
    },
    formatNumberNoComma: (state) => (numeral, number) => {
      return numeral(number).format('0')
    },
    formatNumber: (state) => (number) => {
      // return numeral(number).format('0,0')
      const numberFormat = new Intl.NumberFormat('en-US')
      return numberFormat.format(number)
    },
    statusColor: (state) => (status) => {
      let color = ''
      if (status == 'open') {
        color = 'primary'
      } else if (status == 'ongoing'){
        color = 'warning'
      }
      return color
    }
  },
  actions: {

  },
  plugins: [createPersistedState()]
})
